// extracted by mini-css-extract-plugin
module.exports = {"ChatContentBase":"ChatContent_ChatContentBase__ZANGh","Other":"ChatContent_Other__QNpCp","Myself":"ChatContent_Myself__1ZREh"};